export default __webpack_public_path__ + "static/media/dot_maxtix.9ca4fda6.svg";